module.exports = __webpack_public_path__ + "img/copy.cb0f515a.svg";